import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { OrderSalesListComponent } from './ordersales-list/ordersales-list.component';
import { OrderSalesStep3Component } from './ordersales-step3/ordersales-step3.component';
import { OrderSalesStep1Component } from './ordersales-step1/ordersales-step1.component';
import { OrderSalesStep1ListComponent } from './ordersales-step1-list/ordersales-step1-list.component';
import { OrderSalesStep2ListComponent } from './ordersales-step2-list/ordersales-step2-list.component';
import { OrderSalesStep3ListComponent } from './ordersales-step3-list/ordersales-step3-list.component';
import { OrderSalesStep4ListComponent } from './ordersales-step4-list/ordersales-step4-list.component';
import { OrderSalesStep4Component } from './ordersales-step4/ordersales-step4.component';
import { OrderSalesStep5ListComponent } from './ordersales-step5-list/ordersales-step5-list.component';

@NgModule({
    imports: [
        SharedModule
    ],
    exports: [],
    declarations: [
        OrderSalesListComponent,
        OrderSalesStep1Component,
        OrderSalesStep3Component,    
        OrderSalesStep4Component,    
        OrderSalesStep1ListComponent,        
        OrderSalesStep2ListComponent,
        OrderSalesStep3ListComponent,
        OrderSalesStep4ListComponent,     
        OrderSalesStep5ListComponent
    ],
    providers: [],
})
export class OrderSalesModule { }
